import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = ["onClick"]


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { signInRecordList, signInRecordDelete } from '@/api/yuntuSales/visitToSign'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import { useRouter } from 'vue-router'
import { usePermissionStore } from '@/stores/permission'
const __default__ = { name: 'DcCosLbuVisitToSign' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{ toggle:(row?: BigScoreBakcData) => void }>()
const router = useRouter()

const tableRef = ref()
const permissionStore = usePermissionStore()
const permissionBtn = permissionStore.permission
const showAppid = () => {
  if (permissionBtn.includes('visittosign_fbu_manage_btn')) {
    return 'cos_fbu'
  }
  if (permissionBtn.includes('visittosign_lbu_manage_btn')) {
    return 'cos_lbu'
  }
  if (!permissionBtn.includes('visittosign_fbu_manage_btn') && !permissionBtn.includes('visittosign_lbu_manage_btn')) {
    return ''
  }
}
const queryForm = reactive({
  appId: 'cos_lbu',
  customerNumber: '',
  customerName: '',
  createBy: undefined,
  startTime: '',
  endTime: ''
})
const goDetail = (row: {id:number}) => {
  router.push({
    path: '/lbu/visitToSignDetail',
    query: {
      id: row.id
    }
  })
}

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  console.log('params: ', params)
  const res = await signInRecordList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.search()
}
const columns = computed(() => [
  { title: '客户代码', dataIndex: 'customerNumber' },
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '客户ID', dataIndex: 'cosId' },
  { title: '客户详细地址', dataIndex: 'customerAddress' },
  { title: '签到时间', dataIndex: 'signInTime' },
  { title: '关联访客计划', dataIndex: 'visitPlanTitle' },
  { title: '备注', dataIndex: 'comment' },
  { title: '创建人', dataIndex: 'createByName' },

  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
// const addEdit = (_row?: BigScoreBakcData) => {
//   editModalRef.value?.toggle(_row)
// }
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      signInRecordDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuVisitToSign"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerNumber",
                    label: "客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerNumber) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createBy",
                    label: "创建人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.createBy,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.createBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "startTime",
                    label: "签到时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "cosId",
                    label: "客户ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.cosId) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (goDetail(record))
                  }, _toDisplayString(record.customerName), 9, _hoisted_1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_visittosign_delete']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "308",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_vShow, queryForm.appId==='cos_lbu'],
                [_directive_permission, 'lbu_visittosign_export']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})